module.exports = __webpack_public_path__ + "static/img/216_TO8_2163_og.9434017.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/216_TO8_2163_og.jpg
// module id = kD5H
// module chunks = 0